import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  AvatarGroup,
  Box,
  Icon,
  Typography,
} from '@mui/material';
import { uniqBy } from 'lodash';
import { styled } from '@mui/material/styles';
import AccountCircle from '@mui/icons-material/AccountCircle';
import {
  Task,
  Today,
} from '@mui/icons-material';
import TagList from '../../../../../TagList';

const AvatarGroupStyled = styled(AvatarGroup)({
  '& .MuiAvatarGroup-avatar': {
    width: 24,
    height: 24,
    fontSize: 14,
    border: 'none',
  },
});

const EventAgenda = ({ event }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '18px',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '18px',
      }}
    >
      {event.eventTask
        ? (
          <Today
            sx={{
              height: 16,
              width: 16,
            }}
          />
        )
        : (
          <Task
            sx={{
              height: 16,
              width: 16,
            }}
          />
        )}
      <Box
        sx={{
          display: 'flex',
          alignItem: 'center',
        }}
      >
        <Typography
          variant="caption"
          noWrap
          sx={{
            fontSize: 14,
            ml: 0.5,
            width: 150,
          }}
        >{event.title}
        </Typography>
        <TagList disableGutters tags={event.horseTags} />
      </Box>
    </Box>
    <Box
      sx={{
        display: 'flex',
        alignItem: 'center',
      }}
    >
      {
        event.customStatus && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '18px',
              ml: 1,
            }}
          >
            <Icon
              sx={{ fontSize: '1rem' }}
            >{event.customStatus.icon}
            </Icon>
            <Typography
              variant="caption"
              noWrap
              sx={{
                fontSize: 14,
                ml: 0.5,
                lineHeight: '16px',
              }}
            >
              {event.customStatus.name}
            </Typography>
          </Box>
        )
      }
      <AvatarGroupStyled
        sx={{
          ml: 1,
          width: 70,
        }}
        space={-2}
        _avatar={{ size: 'xs' }}
        max={4}
        total={uniqBy(event.participants, 'userFullName').length}
      >
        {(uniqBy(event.participants, 'userFullName').map((assignment) => (
          assignment.avatar
            ? (
              <Avatar
                sx={{
                  width: 24,
                  height: 24,
                  border: 'none',
                }}
                src={assignment.avatar}
                key={`${event.id}}-${assignment.auth0UserId}`}
              />
            )
            : (
              <Avatar
                sx={{
                  width: 24,
                  height: 24,
                  border: 'none',
                }}
                key={`${event.id}-${assignment.userFullName}`}
                alt={assignment.userFullName}
              >
                <AccountCircle />
              </Avatar>
            )
        ))
          )}
      </AvatarGroupStyled>
    </Box>
  </Box>
)

export default EventAgenda;

EventAgenda.propTypes = { event: PropTypes.object.isRequired }
